var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('IconFaFileCsv'),_vm._v(" "),_c('a',{staticClass:"anchorLink tw-font-bold",attrs:{"href":_vm.downloadAntibodyReferenceCsvLink}},[_vm._v("\n    "+_vm._s(_vm.t('clickHereForAntibodyFeatureReferenceTable'))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }